
import { Geoms, Markers, NoteMarkers, UserLocations } from '../ol-helpers'

import getInitialMap from './getInitialMap'
import layersConfig from './layersConfig'

export default function getInitialMapContextValues() {
  const olMap = getInitialMap(layersConfig);
  // TODO: add marker and geom layers here?
  const geoms = new Geoms();
  olMap.addLayer(geoms.layer);

  const markers = new Markers('marker-layer');
  olMap.addLayer(markers.layer);

  const noteMarkers = new NoteMarkers('note-marker-layer');
  olMap.addLayer(noteMarkers.layer);

  const userLocations = new UserLocations('userLocations-layer');
  olMap.addLayer(userLocations.layer);

  // TODO: handle query click location vs result location
  const showResultOnMap = (data, centerOnResult=true, zoomToBounds=true) => {
    //console.warn('showResultOnMap **************************');
    //console.log(zoomToBounds);
    //console.log(data);
    geoms.clear();
    if (data) {
      const view = olMap.getView();
      if (centerOnResult) {
        view.setCenter(data.markerLocation);
      }
      if (data.geometry) {
        geoms.add(data);
      }
      markers.clear();
      markers.add('x', data.markerLocation);
      //console.log(data.bounds);
      if(data.bounds && zoomToBounds) {
        //console.log(data.bounds);
        view.fit(data.bounds);
      }
    }
  }

  const moveTo = (coordinates) => {
    if (coordinates) {
      const view = olMap.getView();
      view.setCenter(coordinates);
    }
  }

  const zoomCloser = () => {
    const minZoomLevel = 9;
    const view = olMap.getView();
    const currentZoomLevel = view.getZoom();

    if (currentZoomLevel < minZoomLevel) {
        view.setZoom(minZoomLevel);
    }
  }

  //console.log(layersConfig);
  //console.log(olMap);

  return {
    layersConfig,
    olMap,
    geoms,
    markers,
    noteMarkers,
    userLocations,
    moveTo,
    zoomCloser,
    showResultOnMap,
  }
}
